import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { withBasePath } from '_config/basePath';
import { prepareAuthHeaders } from './auth';

export interface Snapshot {
    id: string
    created_at: any
}


export const snapshotApi = createApi({
    reducerPath: 'snapshotApi',
    baseQuery: fetchBaseQuery({
        baseUrl: withBasePath('/api/snapshots'),
        prepareHeaders: prepareAuthHeaders,
        credentials: 'include',
        responseHandler: 'content-type'
    }),
    endpoints: (builder) => ({
        getSnapshots: builder.mutation<Snapshot[], any>({
            query: ({ documentId }) => ({
                url: ``,
                method: 'GET',
                params: { documentId },
            }),
            transformResponse: (response: any) => response.snapshots
        }),
        getSnapshot: builder.mutation<any, any>({
            query: ({ documentId, snapshotId }) => ({
                url: ``,
                method: 'POST',
                body: { documentId, snapshotId },
            }),
        }),
        addSnapshot: builder.mutation<any, any>({
            query: (body) => ({
                url: ``,
                method: 'PUT',
                body
            }),
            transformResponse: (response: any) => response.snapshot
        }),
        shareSnapshot: builder.mutation<any, any>({
            query: (body) => ({
                url: ``,
                method: 'PATCH',
                body
            }),
        }),
    })
});

export const { useGetSnapshotsMutation, useGetSnapshotMutation, useAddSnapshotMutation, useShareSnapshotMutation } = snapshotApi;
